var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { EBillType } from '../../../enum/EBillType';
import { toDetail } from '../../../helper/util';
import HeaderItem from '../../../components/HeaderItem';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.toDeliverDetail = function (item) {
        if (this.formData.logistics_type == 4 || this.formData.logistics_type == 5) {
            toDetail(EBillType.EntrustedDeliver, this.formData.delivery_order_id);
        }
        else {
            toDetail(EBillType.Deliver, this.formData.delivery_order_id);
        }
    };
    __decorate([
        Prop({
            required: true,
        })
    ], default_1.prototype, "formData", void 0);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
